import React from "react";

const typeToClasses = {
  error: {
    container: "bg-red-50 border border-red-200 text-red-800",
    title: "text-red-900",
  },
  warning: {
    container: "bg-brand-cream border border-brand-charcoal/20 text-brand-muted",
    title: "text-brand-charcoal",
  },
  info: {
    container: "bg-brand-cream border border-brand-charcoal/20 text-brand-charcoal",
    title: "text-brand-charcoal",
  },
  success: {
    container: "bg-brand-cream border border-brand-charcoal/20 text-brand-charcoal",
    title: "text-brand-charcoal",
  },
};

export default function InlineAlert({
  type = "error",
  title,
  message,
  children,
  onClose,
  className = "",
}) {
  const classes = typeToClasses[type] ?? typeToClasses.error;
  return (
    <div
      className={`rounded-md p-3 sm:p-4 ${classes.container} ${className}`}
      role="alert"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          {title ? (
            <h4 className={`font-semibold ${classes.title}`}>{title}</h4>
          ) : null}
          {message ? <div className="text-sm">{message}</div> : null}
          {children}
        </div>
        {onClose ? (
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-current/70 hover:text-current"
            aria-label="Dismiss"
          >
            ✕
          </button>
        ) : null}
      </div>
    </div>
  );
}
